export default __webpack_public_path__ + "images/G0.f3c67ab.png";